module.exports = __webpack_public_path__ + "static/media/expYellow.d336756c.svg";